
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fornecedores/[...slugs]",
      function () {
        return require("private-next-pages/fornecedores/[...slugs]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fornecedores/[...slugs]"])
      });
    }
  